/* import RegisterIntoChallengeForm from 'components/RegisterIntoChallengeForm'; */
import DefaultLayout from 'layouts/default';
import { useContext, useEffect, useState } from 'react';
import './index.css';
import Loading from 'components/Loading';
/* import { */
/* getRegistration, */
/* registerIntoChallenge, */
/* RegistrationInfo, */
/* } from 'actions/challenge'; */
import { useSnackbar } from 'notistack';
import { useHistory, useParams } from 'react-router';
import UserContext from 'contexts/user';
const RegistrationIntoChallengePage = () => {
  const [registered, setRegistered] = useState(false);
  const [registerRequestState, setRegisterRequest] = useState('incomplete');
  const [registrationData, setRegistrationData] = useState({
    gitRepo: '',
  });
  const [keys, setKeys] = useState({ public: '' });
  /* const [registerInfo, setRegisterInfo] = useState<RegistrationInfo[]>([]); */
  const { enqueueSnackbar } = useSnackbar();
  const { user, setUser } = useContext(UserContext);
  const history = useHistory();
  const params = useParams<{ id: string }>();

  const onRegister = (registered: boolean, data: typeof registrationData) => {
    setRegistered(registered);
    if (registered) {
      setRegistrationData(data);
    }
  };

  useEffect(() => {
    if (user) {
      /* getRegistration(params.id)
       *   .then((v) => {
       *     setRegisterInfo(v);
       *   })
       *   .catch(() => {
       *     setRegisterInfo([]);
       *   }); */
    }
  }, [user]);
  useEffect(() => {
    if (registered && registerRequestState === 'incomplete') {
      setRegisterRequest('pending');
      let update = false; // whether to send patch or not. If not patch, then post
      /* for (const info of registerInfo) {
       *   if (info.gitRepo === registrationData.gitRepo) {
       *     update = true;
       *     break;
       *   }
       * } */
      /* registerIntoChallenge(
       *   params.id,
       *   {
       *     gitRepo: registrationData.gitRepo,
       *   },
       *   update
       * )
       *   .then((res) => {
       *     enqueueSnackbar('Registered', {
       *       variant: 'success',
       *     });
       *     setRegisterRequest('done');
       *     user?.challenges.push({
       *       name: '',
       *       id: res.data.registration.challengeId,
       *     });
       *     setUser(user);
       *     setKeys({ public: res.data.publicKey });
       *   })
       *   .catch((err) => {
       *     enqueueSnackbar(err.response.data.message, {
       *       variant: 'error',
       *     });
       *     setRegisterRequest('incomplete');
       *   }); */
    }
  }, [registered]);

  if (registered && registerRequestState !== 'done') {
    return (
      <DefaultLayout>
        <Loading text="Generating SSH Keys, please do not leave the page" />
      </DefaultLayout>
    );
  }
  return <DefaultLayout></DefaultLayout>;
};

export default RegistrationIntoChallengePage;
